export default "__VITE_ASSET__7d3ad368__"